"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const react_hook_form_1 = require("react-hook-form");
const UserInfoSection_1 = __importDefault(require("@Scenes/UserRegistrationScenes/UserRegistrationScene/UserRegistrationForm/UserInfoSection"));
const ContactInfoSection_1 = __importDefault(require("@Scenes/UserRegistrationScenes/UserRegistrationScene/UserRegistrationForm/ContactInfoSection"));
const TermsAndCommunicationsSection_1 = __importDefault(require("@Scenes/UserRegistrationScenes/UserRegistrationScene/UserRegistrationForm/TermsAndCommunicationsSection"));
const SubmitButton_1 = __importDefault(require("@App/kit/fields/SubmitButton"));
const common_1 = require("@Const/common");
const user_registration_1 = require("@Entities/schemas/user/user-registration");
const zod_1 = require("@hookform/resolvers/zod");
const MailingAddress_1 = __importDefault(require("@App/kit/fields/v2/MailingAddress"));
const flatten_object_1 = require("@App/helpers/flatten-object");
const MailingAddressToolTip_1 = __importDefault(require("@Components/MailingAddressToolTip"));
const navigation_1 = __importDefault(require("@App/navigation"));
const dayjs_1 = __importDefault(require("dayjs"));
const UserRegistrationForm = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { popupStore, preloaderStore, uiStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const cleanUpData = (data) => {
        var _a, _b;
        const userInfo = (0, flatten_object_1.flattenObject)(data);
        userInfo.firstName = (_a = userInfo.firstName) === null || _a === void 0 ? void 0 : _a.trim();
        userInfo.lastName = (_b = userInfo.lastName) === null || _b === void 0 ? void 0 : _b.trim();
        userInfo.country = Number(data.address.countryId);
        userInfo.phoneCountryCode = Number(data.phoneNumber.phoneCountryCode);
        userInfo.settings = [
            {
                parameter: 'privacyPolicy',
                value: data.privacyPolicy,
            },
            {
                parameter: 'emailCommunications',
                value: data.emailCommunications || false,
            },
            {
                parameter: 'termsAndConditions',
                value: data.termsAndConditions,
            },
        ];
        userInfo.birthday = (0, dayjs_1.default)(data.birthday).format();
        return userInfo;
    };
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        try {
            const creatingUser = cleanUpData(data);
            yield userStore.createUser(creatingUser);
            navigate('/sign-up-complete');
        }
        catch (e) {
            popupStore.setAlertFromError(e);
        }
        finally {
            preloaderStore.openTransparentPreloader(false);
        }
    });
    const { firstName, lastName, birthday, email, termsAndConditions, privacyPolicy, emailCommunications, address, phoneNumber, } = user_registration_1.userRegistrationFormFields;
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750, // MilliSeconds: this delay is here so email validation doesn't start when user starts typing
        resolver: (0, zod_1.zodResolver)(user_registration_1.userRegistrationSchema),
        defaultValues: {
            termsAndConditions: true,
            privacyPolicy: true,
            emailCommunications: true,
        },
    });
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
            react_1.default.createElement(UserInfoSection_1.default, { firstName: firstName, lastName: lastName, birthday: birthday }),
            react_1.default.createElement(MailingAddress_1.default, { title: "Personal Address", toolTip: react_1.default.createElement(MailingAddressToolTip_1.default, null), addressFormFields: address }),
            react_1.default.createElement(ContactInfoSection_1.default, { email: email, phoneNumberFormFields: phoneNumber }),
            react_1.default.createElement(TermsAndCommunicationsSection_1.default, { termsAndConditions: termsAndConditions, privacyPolicy: privacyPolicy, emailCommunications: emailCommunications }),
            react_1.default.createElement(SubmitButton_1.default, { label: "Sign up" }),
            react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.login.root(), onClick: () => uiStore.setOnLoginPage(true), className: "close-wrapper" },
                react_1.default.createElement("img", { src: common_1.ICONS.close, alt: "close" })))));
};
exports.default = (0, mobx_react_1.observer)(UserRegistrationForm);
